export const COMMON_MASTOGRAPHY_STUDIES_SUFFIXES = ['CC', 'MLO'];
